export default __webpack_public_path__ + "static/nur-azizah-49093afb98a0698702311139a18c9d29.webp";